
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/[id]",
      function () {
        return require("private-next-pages/live/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live/[id]"])
      });
    }
  